import Immutable from 'immutable';
import { ActionTypes } from './actions';

export const initialState = Immutable.fromJS({});

const setAll = (state, { allLine }) => {
  if (!allLine) return state;
  return state.merge({ allLine });
};

const setLine = (state, { line }) => {
  if (!line) return state;
  return state.merge({ line });
};

const setLoader = (state, { showLoader }) => {
  return state.merge({ showLoader });
};

const setAllFactoryLines = (state, { factoryLines }) => {
  if (!factoryLines) return false;
  return state.merge({ factoryLines });
};
const setLineDetailOEE = (state, { lineDetailOEE }) => {
  return state.merge({ lineDetailOEE });
};
const setLineTrend = (state, { lineTrend }) => {
  return state.merge({ lineTrend });
};
const setLineVisionEquipments = (state, { visionEquipments }) => {
  return state.merge({ visionEquipments });
};

export const callbacks = [
  {
    actionType: ActionTypes.SET_ALL,
    actionFunction: setAll,
  },
  {
    actionType: ActionTypes.SET_LINE,
    actionFunction: setLine,
  },
  {
    actionType: ActionTypes.SET_LOADER_STATUS,
    actionFunction: setLoader,
  },
  {
    actionType: ActionTypes.SET_ALL_BY_FACTORY_ID,
    actionFunction: setAllFactoryLines,
  },
  {
    actionType: ActionTypes.SET_LINE_DETAIL_OEE,
    actionFunction: setLineDetailOEE,
  },
  {
    actionType: ActionTypes.SET_LINE_TREND,
    actionFunction: setLineTrend,
  },
  {
    actionType: ActionTypes.SET_LINE_VISION_EQUIPMENTS,
    actionFunction: setLineVisionEquipments,
  },
];
